import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../services/core.notification.service';
import { doGetPromise } from '../../config/core.httpclient-utils';

import * as introJs from 'intro.js/intro.js';

@Injectable()
export class TourService {

    private tourName: string = '';
    private tourData: any = false;

    constructor(private httpClient: HttpClient, private notificationService: NotificationService) {}

    setTour(tourName) {
        this.tourName = tourName;
        this.tourData = false;
        this.notificationService.notifyAll(
            'tour', tourName
        );
        return this.tourName;
    }

    hasTour() {
        return this.tourName;
    }

    clearTour() {
        return this.setTour(false);
    }

    getTour() {
        return this.tourName;
    }

    getTourContent() {
        return doGetPromise(
            this.httpClient,
            `/core/tour/${this.tourName}.json`
        ).then((response: any) => {
            this.tourData = response || {};
        }, (response) => { 
            console.log("Could not fetch tour", this.tourName, response);
        });
    }

    runTour() {
        if (! this.tourData) {
            return this.getTourContent().then(
                () => introJs().setOptions(this.tourData).start(),
                () => console.log("Not starting empty tour")
            );
        }

        // If it's already loaded
        introJs().setOptions(this.tourData).start();
    }
}